import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import SubscriptionTagIcon from 'Pods/Shared/Icons/SubscriptionTagIcon'

// Colour signals the MINIMUM tier that unlocks the model, so it follows the model's defining
// (lowest) band - the same rule as the My Models chip. Teal (the base rule) = Essentials,
// extra-purple = Premium. An unknown band keeps the base teal rather than falling through to
// an unstyled label; ModelCard already refuses to render the tag for a null band.
function ModelCardSubEligibleTag({ tierBand = null }) {
  return (
    <div
      className={classnames(
        'card-3d-model__sub-eligible-tag',
        'card-3d-model__sub-eligible-tag--visible',
        tierBand === 'premium' && 'card-3d-model__sub-eligible-tag--premium'
      )}
    >
      <SubscriptionTagIcon
        className="card-3d-model__sub-eligible-tag-icon"
        width="16"
        height="16"
      />
      <span className="card-3d-model__sub-eligible-tag-text">
        FREE IN SUBSCRIPTION
      </span>
    </div>
  )
}

ModelCardSubEligibleTag.propTypes = {
  tierBand: string,
}

export default ModelCardSubEligibleTag
